import type { AssistantAttachment } from "../../../api/types/assistantTypes";

const MEGABYTE = 1024 * 1024;
const MAX_FILE_BYTES = 20 * MEGABYTE;
const MAX_TEXT_BYTES = MEGABYTE;
const MAX_MESSAGE_PAYLOAD_BYTES = 32 * MEGABYTE;
const MAX_ATTACHMENTS_PER_MESSAGE = 10;

const textExtensions = [".txt", ".md"];
export const attachmentExtensions = [
  ".png",
  ".jpg",
  ".jpeg",
  ".webp",
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".csv",
  ...textExtensions,
];

const extensionOf = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex < 0 ? "" : fileName.slice(dotIndex).toLowerCase();
};

export const validateAttachment = (file: File, attachedCount: number): string | undefined => {
  const extension = extensionOf(file.name);
  if (!attachmentExtensions.includes(extension)) {
    return "This type can't be attached. Attach an image, PDF, Word, Excel, CSV or text file.";
  }
  if (attachedCount >= MAX_ATTACHMENTS_PER_MESSAGE) {
    return `You can attach up to ${MAX_ATTACHMENTS_PER_MESSAGE} files to one message.`;
  }
  const maxBytes = textExtensions.includes(extension) ? MAX_TEXT_BYTES : MAX_FILE_BYTES;
  if (file.size > maxBytes) {
    return `Larger than ${maxBytes / MEGABYTE} MB.`;
  }
  return undefined;
};

export const messagePayloadError = (attachments: AssistantAttachment[]): string | undefined => {
  const payloadBytes = attachments.reduce((total, attachment) => total + attachment.modelPayloadBytes, 0);
  return payloadBytes > MAX_MESSAGE_PAYLOAD_BYTES
    ? `These files are too large to send together (over ${MAX_MESSAGE_PAYLOAD_BYTES / MEGABYTE} MB). Remove some of them.`
    : undefined;
};
